import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'tab-bar',
  templateUrl: './tab.bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabBar {
 
  constructor(
    private router: Router,
    private _changedDetectorRef: ChangeDetectorRef
  ) {}
}
